import React from 'react';
import RackImage from 'utils/RackImage';
import { cn } from 'shared/lib/cn';
import { U_PX, type RackUnitModel } from 'shared/lib/rackLayout';

export function RackUnit({ unit, vendorId, photographic, selected, onSelect }: {
  unit: RackUnitModel; vendorId: string; photographic: boolean; selected: boolean; onSelect: () => void;
}) {
  return (
    <button
      type="button"
      data-testid={`rack-unit-${unit.label.replace(/\s+/g, '-')}`}
      onClick={onSelect}
      aria-label={`${unit.label}${unit.jbodLabel ? `, ${unit.jbodLabel}` : ''}`}
      style={{ height: unit.heightU * U_PX }}
      className={cn(
        'flex w-full items-center overflow-hidden rounded-[2px] border text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/60',
        selected ? 'border-brand ring-1 ring-brand/50' : 'border-hairline/25',
        photographic && 'rack-unit-photo bg-surface-high p-[1px]',
      )}
    >
      <RackImage type={unit.type} vendor={vendorId} />
    </button>
  );
}
